export const THEME_PRESETS = {
  nova_dark: {
    label: "Nova Donker",
    description: "Het standaard diepblauwe commandocentrum.",
    colors: {
      bg: "#0B1120",
      surface: "#121C2F",
      surfaceAlt: "#1E293B",
      border: "#1E293B",
      borderStrong: "#334155",
      text: "#F8FAFC",
      textMuted: "#94A3B8",
      textFaint: "#64748B",
      primary: "#2563EB",
      primaryHover: "#3B82F6",
      primaryText: "#FFFFFF",
      accent: "#8B5CF6",
      danger: "#F43F5E",
    },
  },
  midnight_violet: {
    label: "Middernacht Paars",
    description: "Diep paars met elektrische accenten.",
    colors: {
      bg: "#100827",
      surface: "#1B1039",
      surfaceAlt: "#2A1957",
      border: "#2A1957",
      borderStrong: "#3F2678",
      text: "#F5F3FF",
      textMuted: "#A78BFA",
      textFaint: "#7C6EBB",
      primary: "#8B5CF6",
      primaryHover: "#A78BFA",
      primaryText: "#FFFFFF",
      accent: "#EC4899",
      danger: "#F43F5E",
    },
  },
  forest: {
    label: "Diep Bos",
    description: "Rustige smaragdgroene tinten.",
    colors: {
      bg: "#071410",
      surface: "#0F2018",
      surfaceAlt: "#173026",
      border: "#173026",
      borderStrong: "#26493B",
      text: "#F0FDF4",
      textMuted: "#86EFAC",
      textFaint: "#64866F",
      primary: "#10B981",
      primaryHover: "#34D399",
      primaryText: "#052E16",
      accent: "#F59E0B",
      danger: "#EF4444",
    },
  },
  sunset: {
    label: "Zonsondergang",
    description: "Warme amber- en roze tinten.",
    colors: {
      bg: "#1A0F0A",
      surface: "#2A170F",
      surfaceAlt: "#3B2016",
      border: "#3B2016",
      borderStrong: "#553024",
      text: "#FFF7ED",
      textMuted: "#FDBA74",
      textFaint: "#B08768",
      primary: "#F97316",
      primaryHover: "#FB923C",
      primaryText: "#1A0F0A",
      accent: "#EC4899",
      danger: "#EF4444",
    },
  },
  slate: {
    label: "Antraciet",
    description: "Neutraal, gefocust, industrieel.",
    colors: {
      bg: "#0F0F12",
      surface: "#18181B",
      surfaceAlt: "#27272A",
      border: "#27272A",
      borderStrong: "#3F3F46",
      text: "#FAFAFA",
      textMuted: "#A1A1AA",
      textFaint: "#71717A",
      primary: "#F4F4F5",
      primaryHover: "#FFFFFF",
      primaryText: "#09090B",
      accent: "#60A5FA",
      danger: "#F87171",
    },
  },
  paper: {
    label: "Papier Licht",
    description: "Schone witte achtergrond, donkere tekst.",
    colors: {
      bg: "#FAFAF7",
      surface: "#FFFFFF",
      surfaceAlt: "#F1F0EB",
      border: "#E5E4DE",
      borderStrong: "#D4D2C9",
      text: "#111827",
      textMuted: "#4B5563",
      textFaint: "#6B7280",
      primary: "#2563EB",
      primaryHover: "#1D4ED8",
      primaryText: "#FFFFFF",
      accent: "#7C3AED",
      danger: "#DC2626",
    },
  },
  arctic: {
    label: "Arctisch Licht",
    description: "Luchtig, ijsblauw neutraal.",
    colors: {
      bg: "#F1F5F9",
      surface: "#FFFFFF",
      surfaceAlt: "#E2E8F0",
      border: "#E2E8F0",
      borderStrong: "#CBD5E1",
      text: "#0F172A",
      textMuted: "#475569",
      textFaint: "#64748B",
      primary: "#0EA5E9",
      primaryHover: "#0284C7",
      primaryText: "#FFFFFF",
      accent: "#6366F1",
      danger: "#EF4444",
    },
  },
};

export const FONT_OPTIONS = [
  { id: "outfit-manrope", label: "Outfit / Manrope", heading: "Outfit", body: "Manrope" },
  { id: "space-inter", label: "Space Grotesk / Plus Jakarta", heading: "Space Grotesk", body: "Plus Jakarta Sans" },
  { id: "dm-sans", label: "DM Sans", heading: "DM Sans", body: "DM Sans" },
  { id: "sora", label: "Sora / Sora", heading: "Sora", body: "Sora" },
  { id: "playfair", label: "Playfair / Manrope", heading: "Playfair Display", body: "Manrope" },
  { id: "ibm-plex", label: "IBM Plex Sans", heading: "IBM Plex Sans", body: "IBM Plex Sans" },
  { id: "jetbrains", label: "JetBrains Mono", heading: "JetBrains Mono", body: "JetBrains Mono" },
];

export const FONT_SIZE_OPTIONS = [
  { id: "small", label: "Klein", scale: 0.92 },
  { id: "normal", label: "Normaal", scale: 1 },
  { id: "large", label: "Groot", scale: 1.1 },
];

export const DENSITY_OPTIONS = [
  { id: "compact", label: "Compact", pad: 0.75 },
  { id: "comfortable", label: "Comfortabel", pad: 1 },
  { id: "spacious", label: "Ruim", pad: 1.25 },
];

export const DEFAULT_SETTINGS = {
  preset: "nova_dark",
  colors: THEME_PRESETS.nova_dark.colors,
  fonts: { id: "outfit-manrope", heading: "Outfit", body: "Manrope" },
  font_size: "normal",
  density: "comfortable",
};

export function hexToRgb(hex) {
  const h = hex.replace("#", "");
  const s = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const num = parseInt(s, 16);
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

export function isLightBackground(hex) {
  const { r, g, b } = hexToRgb(hex);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6;
}
